// extracted by mini-css-extract-plugin
export default {"inputOTP":"inputotp_inputOTP__9cPmx"};